import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { DayboardDateService } from '../dayboard-date.service';

@Component({
    selector: 'nuctrac-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;

  showNavBar = false;
  hideHeader: boolean;
  showMobilePanel: boolean = false;
  showMobile: boolean;

  collapseMobile: boolean = false;

  expandMobile: boolean;
  expandNoMobile: boolean;
  constructor(
    private observer: BreakpointObserver,
    private dayBoardService: DayboardDateService
  ) {}

  ngOnInit(): void {
  }

  onClickeMenuIcon() {
    this.showNavBar = !this.showNavBar;
  }

  setHeaderStatus(value) {
    this.hideHeader = value;
    this.dayBoardService.headerCollapesed$.next(this.hideHeader);
  }
  setMobileStatus(value) {
    this.showMobilePanel = value;
    // this.dayBoardService.headerCollapesed$.next(this.showMobilePanel);
  }
  setMobileStatusSelect(value) {
    this.showMobile = value;
   

    // this.dayBoardService.headerCollapesed$.next(this.showMobilePanel);
  }

  ngAfterViewInit() {
    this.observer.observe(['(max-width: 800px)']).subscribe((res) => {
      if (res.matches) {
        this.showNavBar = false;
        // this.sidenav.mode = 'over';
        // this.sidenav.close();
      } else {
        this.showNavBar = true;
        // this.sidenav.mode = 'side';
        // this.sidenav.open();
      }
    });
  }
}
